// src/components/network/discover/TrendingTopics.jsx
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Flame, TrendingUp, Hash } from 'lucide-react';
import { db } from '../../../firebase/config';
import { collection, query, orderBy, limit, getDocs } from 'firebase/firestore';

const TrendingTopics = () => {
  const [trendingTags, setTrendingTags] = useState([]);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    const fetchTrendingTags = async () => {
      try {
        setLoading(true);
        
        // This is a simplified example - in a real app, you might have a 
        // separate collection for tracking trending tags
        // For now we'll just get recent posts and extract tags
        const postsQuery = query(
          collection(db, 'posts'),
          orderBy('createdAt', 'desc'),
          limit(50) // Get enough posts to find trending tags
        );
        
        const postsSnapshot = await getDocs(postsQuery);
        
        // Count tag occurrences
        const tagCounts = {};
        
        postsSnapshot.docs.forEach(doc => {
          const post = doc.data();
          if (post.tags && Array.isArray(post.tags)) {
            post.tags.forEach(tag => {
              tagCounts[tag] = (tagCounts[tag] || 0) + 1;
            });
          }
        });
        
        // Convert to array and sort by count
        const sortedTags = Object.entries(tagCounts)
          .map(([tag, count]) => ({ tag, count }))
          .sort((a, b) => b.count - a.count)
          .slice(0, 10); // Get top 10
        
        setTrendingTags(sortedTags);
        
      } catch (error) {
        console.error('Error fetching trending tags:', error);
      } finally {
        setLoading(false);
      }
    };
    
    fetchTrendingTags();
    
    // In a real app, you might fetch trending topics periodically
    const interval = setInterval(fetchTrendingTags, 30 * 60 * 1000); // Every 30 minutes
    
    return () => clearInterval(interval);
  }, []);
  
  if (loading && trendingTags.length === 0) {
    return (
      <div className="bg-white rounded-xl shadow-sm p-6 border border-gray-200">
        <div className="flex items-center mb-4">
          <Flame size={18} className="text-[#190192] mr-2" />
          <h3 className="text-lg font-medium text-gray-900">Trending Topics</h3>
        </div>
        <div className="animate-pulse space-y-3">
          {[...Array(5)].map((_, i) => (
            <div key={i} className="h-6 bg-gray-200 rounded w-3/4"></div>
          ))}
        </div>
      </div>
    );
  }
  
  return (
    <div className="bg-white rounded-xl shadow-sm p-6 border border-gray-200">
      <div className="flex items-center mb-4">
        <Flame size={18} className="text-[#190192] mr-2" />
        <h3 className="text-lg font-medium text-gray-900">Trending Topics</h3>
      </div>
      
      {trendingTags.length === 0 ? (
        <p className="text-gray-500 text-sm">
          No trending topics at the moment. Check back later!
        </p>
      ) : (
        <ul className="space-y-3">
          {trendingTags.map(({ tag, count }) => (
            <li key={tag}>
              <Link
                to={`/network/tag/${tag}`}
                className="flex items-center justify-between group"
              >
                <div className="flex items-center">
                  <Hash size={16} className="text-gray-400 mr-2" />
                  <span className="text-gray-600 group-hover:text-[#190192]">#{tag}</span>
                </div>
                <div className="flex items-center text-gray-400 text-sm">
                  <span>{count} posts</span>
                  <TrendingUp size={14} className="ml-1" />
                </div>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default TrendingTopics;